<template>
	<div class="page2_main_layout_phone">
		<div class="page2_main_title">
			项目案例
		</div>
		<div class="phone_product_list_1" style="margin-top: 60px;">
			<div class="phone_product_list_item" :id="'4_' + item.id" v-for="item in product_list_data_3"
				@click="show_one_product('4_' + item.id)">
				<!-- :style="item.style" -->
				<div :class="'phone_product_list_item_img ' + 'case_img_' + item.id">

				</div>
				<div class="phone_product_list_item_title">
					{{ item.title }}
				</div>
				<div class="phone_product_list_item_content">
					{{ item.content }}
				</div>

			</div>
		</div>
	</div>


	<div class="page1_main_layout">
		<div class="page2_main_content_layout" id="page2_section1">
			<div class="page2_content_title">
				<div class="page2_content_title_icon"></div>
				<div class="page2_content_title_text">
					项目案例
				</div>
			</div>
			<!-- :style="item.id%5==0?'height: 360px;margin-right: 0px;':'height: 360px;margin-bottom: 20px;'" -->

			<div class="page2_content_item" v-for="item in product_list_data_3"
				@click="show_one_product('4_' + item.id)">
				<div class="page2_content_item_layout">
					<div class="page2_content_item_title">
						{{ item['title'] }}
					</div>

					<!-- <div :class="'page2_content_item_img ' + 'case_img_' + item.id"
						:style="'margin-top: 10px;margin-left: 15px;height: 180px;width: 200px;' + item.style"> -->
					<div :class="'page2_content_item_img ' + 'case_img_' + item.id"
						:style="'margin-top: 10px;margin-left: 14px;height: 180px;width: 200px;'">

					</div>
					<!-- <div class="page2_content_item_text" style="height: 110px;">
						{{ item['content'] }}
					</div> -->
				</div>


			</div>

		</div>
	</div>





	<div class="page2_show_menu" v-if="false">
		<div class="page2_show_menu_item" @click="click_page3_show_menu(0)">
			<div>接口介绍</div>
			<a href="#page3_section0" id="page3_show_menu_item_0" style="visibility: hidden;">接口介绍</a>
		</div>
		<div class="page2_show_menu_item" @click="click_page3_show_menu(1)">
			<div>电力应急设备库存跟踪监控</div>
			<a href="#page3_section1" id="page3_show_menu_item_1" style="visibility: hidden;">电力应急设备库存跟踪监控</a>
		</div>
		<div class="page2_show_menu_item" @click="click_page3_show_menu(2)">
			<div>M2BA-M²分析仪</div>
			<a href="#page3_section2" id="page3_show_menu_item_2" style="visibility: hidden;">M2BA-M²分析仪</a>
		</div>
		<div class="page2_show_menu_item" @click="click_page3_show_menu(3)">
			<div>飞参识别系统</div>
			<a href="#page3_section3" id="page3_show_menu_item_3" style="visibility: hidden;">飞参识别系统</a>
		</div>
		<div class="page2_show_menu_item" @click="click_page3_show_menu(4)">
			<div>猫眼光纤识别</div>
			<a href="#page3_section4" id="page3_show_menu_item_4" style="visibility: hidden;">猫眼光纤识别</a>
		</div>
	</div>
	<div class="page3_main_layout" v-if="false">


		<div class="page3_show_title_line_0" id="page3_section0">
			接口介绍
		</div>
		<div class="page3_show_title_line" id="page3_section1">
			电力应急设备库存跟踪监控
		</div>
		<div class="page3_show_title_line_2" id="page3_section2">
			M2BA-M²分析仪
		</div>
		<div class="page3_show_title_line_3" id="page3_section3">
			飞参识别系统
		</div>
		<div class="page3_show_title_line_4" id="page3_section4">
			猫眼光纤识别
		</div>

		<div class="page3_show_content">
			<div class="page1_show_content_list">
				<div class="page1_show_content_item " v-for="item in api_list_data" @click="click_one_btn(item)">
					<div :class="'page1_show_content_item_icon ' + 'api_show_img_' + item.id">

					</div>
					<div class="page1_show_content_item_title">
						{{ item.title }}
					</div>
					<div class="page1_show_content_item_text">

						{{ item.content }}
					</div>
					<div :class="'show_before_api_img ' + 'show_before_api_img_' + item.id">

					</div>
					<div class="before_to_after_arrow">

					</div>
					<div :class="'show_after_api_img ' + 'show_after_api_img_' + item.id">

					</div>
					<div class="show_api_tip_btn">
						<!-- 点击使用 -->
					</div>
				</div>
			</div>
		</div>

		<div class="page3_show_layout">
			<div class="page3_show_content_1">

			</div>
			<div class="page3_show_content_2">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;color: #00aaff;">电力应急设备库存跟踪监控</div>

				<div style="margin-top: 20px;">
					通过计算机视觉和物联网技术实现对供电应急设备仓库的智能化管理。进行实时库存统计，自动更新库存信息，避免人工盘点误差，确保库存数据的准确性和及时性。
				</div>

				<div style="margin-top: 10px;">
					<div style="font-weight: 600;color: #00aaff;">应用场景</div>
					<div>·库存管理</div>
					<div>·电力设备库房管理</div>
					<div>·电力应急设备跟踪</div>
				</div>
				<div style="margin-top: 10px;">
					<div style="font-weight: 600;color: #00aaff;">产品特点</div>
					<div>·自动监控工作人员从仓库中取走或归还设备的操作</div>
					<div>·实时库存统计</div>
					<div>·人员身份确认</div>
				</div>
				<div style="margin-top: 10px;">
					<div style="font-weight: 600;color: #00aaff;">系统优势</div>
					<div>·自动化管理：无需人工干预，系统通过视觉识别设备和操作人员，自动完成借还设备记录。</div>
					<div>·实时库存更新：确保设备库存信息的实时性和准确性，减少库存错误。</div>
					<div>·高效管理：减少人工操作时间，提升仓库管理效率。</div>
				</div>
			</div>
			<div class="page3_show_content_3">

			</div>
			<div class="page3_show_content_4">

			</div>
			<div class="page3_show_content_5">

			</div>
			<div class="page3_show_content_6">

			</div>

			<div class="page3_show_content_7">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;color: #00aaff;">M2BA-M²分析仪</div>
				<div style="margin-top: 20px;">
					指向稳定性测试功能——显示了 稳定性与时间的关系，质心横坐标、质心纵坐标峰值位置与时间的函数关系。
				</div>
				<div style="margin-top: 10px;">
					<div style="font-weight: 600;color: #00aaff;">应用场景</div>
					<div>·用于产品的质量控制和性能评估测量和分析激光束的空间光斑质量、光强分布、光束发散度等参数，确保产品的质量和性能符合标准要求</div>
					<div>·提供关于激光束的尺寸、形状、模式等详细信息，辅助用户调整和优化产品的参数，提高产品的效率和性能</div>
				</div>
				<div style="margin-top: 10px;">
					<div style="font-weight: 600;color: #00aaff;">产品特点</div>
					<div>·实时监控光斑形状以及变化</div>
					<div>·测量激光光束的M²大小、束腰直径D0、发散角theta、椭圆度等</div>
					<div>·符合国际ISO11146标准</div>
					<div>·2D，3D伪彩色光束轮廓</div>
					<div>·产品测量功率范围、测量波长可定制</div>
				</div>
			</div>
			<div class="page3_show_content_8">

			</div>
			<div class="page3_show_content_9">

			</div>

			<div class="page3_show_content_10">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;color: #00aaff;">飞参识别系统</div>
				<div style="margin-top: 10px;">
					<div style="font-weight: 600;color: #00aaff;">应用场景</div>
					<div>·用各类模拟飞机仪表盘飞行参数提取。</div>
					<div>·P3D、X-plane、DCS world和Microsoft Flight Simulator的飞行训练模拟数据的读取</div>
				</div>
				<div style="margin-top: 10px;">
					<div style="font-weight: 600;color: #00aaff;">产品特点</div>
					<div>·实时处理模拟飞机屏幕视频流</div>
					<div>·框选识别功能</div>
					<div>·多目标识别</div>
					<div>·可以识别飞行高度与飞行过载</div>
				</div>
				<div style="margin-top: 10px;">
					<div style="font-weight: 600;color: #00aaff;color: #00aaff;">识别流程</div>
					<div>·可以选择本地mp4文件，摄像头IP端口的视频流以及网络视频流实现实时在线检测</div>
					<div>·将视频流输入分割为一帧一帧的图像，放入到YOLO实时目标检测模型中进行仪表定位</div>
					<div>·对定位到的仪表进行截取，然后输入到PaddleOCR字符识别模型中对仪表内容进行识别</div>
				</div>
			</div>
			<div class="page3_show_content_11">

			</div>
			<div class="page3_show_content_12">

			</div>
			<div class="page3_show_content_13">

			</div>

			<div class="page3_show_content_14">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;color: #00aaff;">猫眼光纤识别</div>
				<div style="margin-top: 10px;">
					<div>
						右图是猫眼光纤的示意图。熊猫型保偏光纤包括包层3、应力区2、纤芯1，所述纤芯1位于包层3的中心，所述应力区2(也称为熊猫眼)对称设置在纤芯1的两侧且位于包层3中，这种光纤具有制作工艺成熟和产品性能一致的优点，因此正被广泛应用于光纤通信、光纤激光以及光纤传感等系中。
					</div>
				</div>
				<div style="margin-top: 10px;">
					<div>·微米级别的光纤端面，通过打光之后捕捉到的端面情况仍然存在模糊、脏污、不清晰和打光偏差强弱不同的情况</div>
				</div>
				<div style="margin-top: 10px;">
					<div>·生产过程中，需要识别猫眼的角度，圆的大小，以便进行2根光纤之间轴对齐，判断猫眼产品是否合格</div>
				</div>
				<div style="margin-top: 10px;">
					<div>·通过二极化或者其他的图像处理手段，只保留熊猫眼以及光纤边缘，过滤掉其他部分的杂质干扰。同时对边缘轮廓进行圆心拟合，识别熊猫眼和光纤的直径大小，以及中心点的位置。</div>
				</div>
				<div style="margin-top: 10px;">
					<div>·图片预处理：使用OpenCV读取图像文件，对图像进行裁剪，自适应阈值二值化，轮廓获取</div>
				</div>
				<div style="margin-top: 10px;">
					<div>·圆的识别：采用霍夫圆算法提取图片中的圆</div>
				</div>
				<div style="margin-top: 10px;">
					<div>·角度计算：计算圆心连接线和轴线之间的夹角</div>
				</div>
			</div>
			<div class="page3_show_content_15">

			</div>
			<div class="page3_show_content_16">

			</div>
		</div>
		<!-- indicator-position="none" 
			:autoplay="false"	
		-->
		<!-- 		<el-carousel 
			height="830px" 
			trigger="click" 
			motion-blur 
			arrow="always"
		>
		    <el-carousel-item >
				<div class="page3_carousel_item page3_carousel_item_1" >
					
				</div>
		    </el-carousel-item>
			<el-carousel-item >
			    <div class="page3_carousel_item page3_carousel_item_3" >
			    	
			    </div>
			</el-carousel-item>
			<el-carousel-item >
			    <div class="page3_carousel_item page3_carousel_item_4" >
			    	
			    </div>
			</el-carousel-item>
			<el-carousel-item >
			    <div class="page3_carousel_item page3_carousel_item_5" >
			    	
			    </div>
			</el-carousel-item>
		</el-carousel> -->
	</div>
	<Footer></Footer>

</template>

<script>
import request from "@/utils/request";
import Footer from '@/components/Footer'

export default {
	name: "page3",
	components: {
		Footer
	},
	data() {
		return {
			base_url: SERVER_URL,
			// api_list_data:[],
			// product_list_data_1:[],
			// product_list_data_2:[],
			product_list_data_3: [],
		}
	},
	mounted() {

		document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0

		// this.api_list_data = this.$GLOBAL.api_list_data
		// this.product_list_data_1 = this.$GLOBAL.product_list_data_1
		// this.product_list_data_2 = this.$GLOBAL.product_list_data_2
		this.product_list_data_3 = this.$GLOBAL.product_list_data_3

		// request.get(this.$GLOBAL.flask_web_local_url+'/get_map_data_info').then(res => {
		// 	console.log(res)
		// })


		this.$GLOBAL.methods.init_header_menu("page3")

		setTimeout(function () {
			let sub_item_id = window.localStorage.getItem("sub_4_item_id")
			var element = document.getElementById(sub_item_id);
			// console.log(sub_item_id)
			if (element) {
				var offset = element.offsetTop;
				document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = offset
			}
		})
		setTimeout(function () {
			let item_list = document.getElementsByClassName("page2_content_item")
			// console.log(item_list.length)
			for (let i = 0; i < item_list.length; i++) {
				if (i != 0 && (i + 1) % 5 == 0) {
					item_list[i].style.marginRight = "0px"
					// console.log(item_list[i])
				}
			}
		}, 20)

		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_1', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_2', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_3', 'rgba(85, 255, 255, 0.7)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_4', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_5', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_6', 'rgba(255, 255, 255, 0.4)')

	},
	methods: {
		show_one_product(id) {
			window.localStorage.setItem("sub_4_item_id", id);
			window.localStorage.setItem("sub_path", id);
			window.localStorage.setItem("main_path", "show_product");
			this.$router.push("/main/show_product")
		},
		click_one_btn(item) {
			// console.log(item)
			window.localStorage.setItem("show_id", item.id);
			this.$router.push("/main/page_api_1")
		},
		click_page3_show_menu(index) {

			document.getElementById("page3_show_menu_item_" + index).click();
			// console.log(document.getElementById("page3_show_menu_item_"+index))
			// window.localStorage.setItem("show_id",item.id);
			// this.$router.push("/main/page_api_1")
		},
	},
}
</script>

<style></style>